/**
 * Created by mukund on 7/17/15.
 */

'use strict';

angular.module('mediacloudApp')
    .controller('QuizSubmissionController', function($scope, $compile, $state, $stateParams, $window, $rootScope, $filter, Principal, AssetService, CollectionService, AVMedia, $timeout) {

        Principal.identity().then(function(account) {
            var logger = function(msg) {
                var active = false;

                if (active) {
                    console.log(msg);
                }
            }

            var assetId = $state.params.assetId;
            var collectionId = $state.params.collectionId;
            var collectionType = 'course';
            $scope.isPreview = $state.params.isPreview;
            $scope.isAssignmentFromLMS = sessionStorage.getItem('isAssignmentFromLMS') === "true";
            $scope.isInstructor = false;
            $scope.rootCollectionType = collectionType;
            $scope.quiz = {};
            $scope.hasWritePermissions = false;
            $scope.breadcrumbLoaded = false;
            $scope.submissionIdentifier = '';

            $scope.$watch("[breadcrumbLoaded, isPreview, isAssignmentFromLMS, hasWritePermissions]",
                function () {
                    if ($scope.breadcrumbLoaded) {
                        if ($scope.isAssignmentFromLMS && (!$scope.hasWritePermissions || $scope.isPreview)) {
                            $('.breadcrumb').css('visibility', 'hidden');
                        }else if ($scope.isAssignmentFromLMS && $scope.hasWritePermissions) {
                            $(".breadcrumb").each(function () {
                                var el = $(this);
                                el.addClass("non-interactive");
                                $timeout(function(){
                                    // Disable keyboard focusability for all children
                                    el.find("a, button, input, [tabindex]").each(function () {
                                        $(this).attr("tabindex", "-1");
                                        $(this).attr("disabled", true); // Only affects elements that support it
                                    });
                                    // Prevent Enter/Space key activation
                                    el.on("keydown", function (e) {
                                        if (e.key === "Enter" || e.key === " " || e.key === "Spacebar") {
                                            e.preventDefault();
                                            e.stopPropagation();
                                        }
                                    });
                                },0);
                            });
                            $('.breadcrumb').css('visibility', 'visible');
                        }
                    }
                },
                true
            );

            var loadPageInfo = function() {
                AssetService.GetAsset.get({
                    cid: collectionId,
                    aid: assetId
                }, function(asset) {
                    $scope.asset = asset;
                    $scope.rootCollectionId = $scope.asset.rootLevelCid;
                    $rootScope.rootLevelCid = $scope.asset.rootLevelCid;
                    $rootScope.rootCollectionId = $scope.asset.rootLevelCid;
                    $scope.hideCurrentFolderOnBreadcrumb = !$scope.rootCollectionId;
                    $scope.hasWritePermissions = $scope.asset.acl.indexOf('W') > -1;
                    $scope.isInstructor = $scope.asset.acl.indexOf("W") > -1;
                    $scope.getQuizMetadata();
                    console.log('asset: ', $scope.asset);
                    $scope.getCollections();
                    AssetService.GetQuizInfo.get({
                        cid: $scope.asset.cid,
                        aid: $scope.asset.aid
                    }, function(quiz) {
                        $scope.mmQuiz = quiz;
                        console.log('mmQuiz: ', $scope.mmQuiz);
                    });
                });
            };

            $scope.getQuizMetadata = function() {
                AssetService.GetQuizMetadata.get({
                    cid: collectionId,
                    aid: assetId
                }, function(quiz) {
                    $scope.quiz = quiz;
                    console.log('quiz: ', $scope.quiz);
                    AssetService.GetQuizSummaryReport.get({
                        quizId: $scope.quiz.id,
                    }, function(response) {
                        console.log('GetQuizSummaryReport: ', response);
                    });
                    AssetService.GetQuizTakerSubmissionReport.get({
                        quizId: $scope.quiz.id,
                        username: account.login,
                        isPreview: $scope.isPreview,
                    }, function(response) {
                        console.log('GetQuizTakerSubmissionReport: ', response);
                        $scope.quizTakerReportSubmissions = response;
                        if ($scope.quizTakerReportSubmissions.submissions.length) {
                            $scope.currentQuizTakerReportSubmission = $scope.quizTakerReportSubmissions.submissions[$scope.quizTakerReportSubmissions.submissions.length - 1];
                        }
                        $scope.selectedQuizAttemptId = $scope.currentQuizTakerReportSubmission.quizAttemptIdFormatted;
                        if ($scope.currentQuizTakerReportSubmission) {
                            var questions = $scope.currentQuizTakerReportSubmission.questions;
                            $scope.quizAttemptNumber = $scope.currentQuizTakerReportSubmission.index;
                            $scope.submissionIdentifier = $scope.currentQuizTakerReportSubmission.submissionIdentifier;
                        }
                        $scope.contributor = $scope.quizTakerReportSubmissions.quizTaker.name;
                        $('.quiz-page').show();
                    });
                });
            }

            $scope.handleDownloadConfirmationCardClick = function() {
                var element = document.getElementById('confirmation-card');
                var scale = 3; // For higher resolution
                // Create canvas
                var canvas = document.createElement('canvas');
                var context = canvas.getContext('2d');
                var width = element.offsetWidth + 50;
                var height = element.offsetHeight;
                canvas.width = width * scale;
                canvas.height = height * scale;
                context.scale(scale, scale);
                // Draw HTML to canvas
                var data = new XMLSerializer().serializeToString(element);
                var svg = '<svg xmlns="http://www.w3.org/2000/svg" width="' + width + '" height="' + height + '"><foreignObject width="100%" height="100%">' + data + '</foreignObject></svg>';
                var url = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svg);
                var img = new Image();
                img.onload = function() {
                    context.drawImage(img, 0, 0);
                    // Download as PNG
                    var link = document.createElement('a');
                    link.download = 'download.png';
                    link.href = canvas.toDataURL('image/png');
                    link.click();
                };
                img.src = url;
            }

            function onTempImageLoad(e){
              ctx.drawImage(e.target, 0, 0)
              targetImg.src = canvas.toDataURL()
            }

            $scope.handleRetakeQuizClick = function() {
                $scope.handleParentQuizClick();
            }

            $scope.exitPreviewMode = function () {
                $window.history.back();
            };

            var manageBreadcrumbTruncation = function() {
                var assetTitleIntervalId = setInterval(function() {
                    if ($('.breadcrumb .asset-name .name').length) {
                        clearInterval(assetTitleIntervalId);

                        var breadcrumbInterval = setInterval(function() {
                            if (
                                $('.breadcrumb .sub-folder .name').height() > 0 ||
                                $('.breadcrumb .current-folder .name').height() > 0 ||
                                $('.breadcrumb .asset-name .name').height() > 0
                            ) {
                                clearInterval(breadcrumbInterval);

                                //If the breadcrumb is bigger than the max width
                                var isBreadcrumbBigger = $('.breadcrumb .sub-folder .name').height() > 28 ||
                                    $('.breadcrumb .current-folder .name').height() > 28 ||
                                    $('.breadcrumb .asset-name .name').height() > 28;

                                if (isBreadcrumbBigger) {
                                    //If each subfolder is bigger than the limit
                                    if (
                                        hasEllipsisWidth($('.breadcrumb .sub-folder')[0]) ||
                                        hasEllipsisWidth($('.breadcrumb .current-folder')[0]) ||
                                        hasEllipsisHeight($('.breadcrumb .asset-name')[0])
                                    ) {

                                        //Add ellipsis to subfolders that are wider than the limit
                                        $('.breadcrumb .sub-folder .name').addClass('truncate-ellipsis');
                                        $('.breadcrumb .sub-folder .name').addClass('limit-folder-size');
                                        $('.breadcrumb .current-folder .name').addClass('truncate-ellipsis');
                                        $('.breadcrumb .current-folder .name').addClass('limit-folder-size');

                                        //TODO: get player width - .root-container width
                                        var nameWidthIntervalId = setInterval(function() {
                                            if ($('.breadcrumb .root-collection .name').width()) {
                                                clearInterval(nameWidthIntervalId);

                                                var subFoldersWidth = 0;
                                                $('.breadcrumb .sub-folder').each(function(index, item) {
                                                    subFoldersWidth += $(item).width() + 16;
                                                });

                                                // var assetNameWidth = $('#player').width() - titleWidth - subFoldersWidth - 40;
                                                var assetNameWidth = 187;

                                                $('.breadcrumb .asset-name .name').addClass('truncate-ellipsis');
                                                $('.breadcrumb .asset-name .name').css('max-width', assetNameWidth.toString() + 'px');
                                            }
                                        }, 10)
                                    }

                                    $scope.showSubFolderTooltip = [];


                                    if ($('.breadcrumb .sub-folder').length > 0) {
                                        $scope.showSubFolderTooltip[0] = hasEllipsisWidth($('.breadcrumb .sub-folder .name')[0]);
                                    }

                                    if ($('.breadcrumb .sub-folder').length > 1) {
                                        $scope.showSubFolderTooltip[1] = hasEllipsisWidth($('.breadcrumb .sub-folder .name')[1]);
                                    }

                                    if ($('.breadcrumb .sub-folder').length > 2) {
                                        $scope.showSubFolderTooltip[2] = hasEllipsisWidth($('.breadcrumb .sub-folder .name')[2]);
                                    }
                                }

                                if (hasEllipsisWidth($('.breadcrumb .current-folder .name')[0])) {
                                    $scope.showCurrentFolderTooltip = true;
                                }

                                setTimeout(function() {
                                    if (hasEllipsisWidth($('.breadcrumb .asset-name .name')[0])) {
                                        $scope.showAssetTooltip = true;
                                    }
                                }, 1000)

                                $('.breadcrumb').css('opacity', 1);
                            }
                        }, 50)
                    }
                }, 10)
            }

            $scope.getCollections = function() {
                logger('getCollections')

                CollectionService.GetCollection.get({
                    cid: collectionId,
                    type: collectionType.toUpperCase()
                }, function(parentCollection) {
                    $scope.parent = parentCollection;
                    $scope.parentCollection = parentCollection;
                    $scope.currentCollection = parentCollection;
                    $scope.isMediaInboxCollection = $scope.currentCollection.type === 'dropbox' ||
                        $scope.currentCollection.type === 'assignment' ||
                        $scope.currentCollection.type === 'zoom';

                    var collectionTreeIntervalId = setInterval(function() {
                        if ($scope.collectionTree) {
                            clearInterval(collectionTreeIntervalId);
                            $scope.currentCollection.crumbs = generateCrumbs(parentCollection.cid, parentCollection.path);
                            $scope.showBreadcrumbEllipsis = $scope.currentCollection.crumbs.length > 1;

                            //show only last 2 subfolders
                            $scope.breadcrumbFolders = $scope.currentCollection.crumbs.slice($scope.currentCollection.crumbs.length - 1, $scope.currentCollection.crumbs.length);
                            $scope.breadcrumbLoaded = true;
                            $scope.crumbsForMenu = JSON.parse(JSON.stringify($scope.currentCollection.crumbs.slice(0, $scope.currentCollection.crumbs.length - 1)));

                            setTimeout(function() {
                                manageBreadcrumbTruncation();
                            }, 500)
                        }
                    }, 50);

                    $scope.currentCollection.pathLength = parentCollection.path.split('/').length;
                    var arrPath = parentCollection.path.split('/');
                    if (arrPath.length > 2) {

                        if ($scope.rootCollectionId) {
                            CollectionService.GetCollection.get({
                                cid: $scope.rootCollectionId,
                                type: collectionType.toUpperCase()
                            }, function(collection) {
                                $scope.collection = collection;
                                $rootScope.rootLevelCollectionTitle = collection.title;
                            });
                        }

                    } else {
                        if (!$scope.rootCollectionId) {
                            $scope.rootCollectionId = $scope.asset.cid;
                            collectionId = $scope.rootCollectionId;
                        }

                        CollectionService.GetCollection.get({
                            cid: $scope.rootCollectionId,
                            type: collectionType.toUpperCase()
                        }, function(collection) {
                            $scope.collection = collection;
                            $rootScope.rootLevelCollectionTitle = collection.title;
                        });
                    }
                });
            }

            loadPageInfo();

            $scope.getCollectionTree = function() {
                logger('getCollectionTree');

                var intervalId = setInterval(() => {
                    if ($scope.rootCollectionId) {
                        clearInterval(intervalId);
                        //rootCollectionId 2
                        CollectionService.GetCollectionTree.get({
                            cid: $scope.rootCollectionId
                        }, function(tree) {
                            $scope.collectionTree = tree;
                            $scope.collectionTree.show = false;
                            // $('.course-breadcrumb-text').css({"width" : "auto", "max-width" : "95%"});

                            //here
                        });
                    }
                }, 100)
            }

            var generateCrumbs = function(cid, path) {
                logger("generateCrumbs");

                var crumbs = [];
                if (path) {
                    var parents = path.split("/").slice(3);
                    if (parents.length && $scope.collectionTree) {
                        angular.forEach(
                            $scope.collectionTree.children,
                            function(node) {
                                getCrumbs(node, crumbs, cid, parents);
                            }
                        );
                    }
                }

                return crumbs;
            };

            $scope.handleRedirectToResults = function() {
                $state.go("quizzingReportStudent", {
                    collectionId: $scope.quiz.collectionId,
                    assetId: $scope.quiz.assetId,
                    quizId: $scope.quiz.id,
                    showResyncButton: false,
                    isPreview: $scope.isPreview,
                });
            };

            // recursive function that gets all parent nodes of a collection from the collection tree
            var getCrumbs = function (node, crumbs, cid, parents) {
                logger("getCrumbs");
                if (node.cid && parents.indexOf(node.cid) !== -1) {
                    crumbs.push({
                        title: node.title,
                        cid: node.cid,
                    });
                }
                angular.forEach(node.children, function (child) {
                    getCrumbs(child, crumbs, cid, parents);
                });
            };

            var hasEllipsisHeight = function(el) {
                if (el.offsetHeight && el.scrollHeight) {
                    return el.offsetHeight < el.scrollHeight;
                }

                return null;
            }

            var hasEllipsisWidth = function(el) {
                if (el && el.offsetWidth && el.scrollWidth) {
                    return el.offsetWidth < el.scrollWidth;
                }

                return null;
            };

            $scope.getCollectionTree();

            $scope.handleBreadCrumbCurrentCollectionClick = function(cid) {
                $scope.navigateToCollection({
                    type: "Collection",
                    xid: cid,
                });
            };

            $scope.handleBreadcrumbRootContainerClick = function(cid) {
                $scope.navigateToCollection({type: 'Collection', xid: cid})
            }

            $scope.navigateToCollection = function (content) {
                logger("navigateToCollection");
                $scope.goBack(content);
            };

            $scope.goBack = function (content) {
                logger("goBack");
                if (
                    $scope.parent.type === "course" ||
                    $scope.parent.type === "collection" ||
                    $scope.parent.type === "dropbox" ||
                    $scope.parent.type === "assignment" ||
                    $scope.parent.type === "zoom"
                ) {
                    if ($scope.hideHeaderAndFooter) {
                        $state.go("lmsCourse", {
                            collectionId:
                                ($scope.collectionTree &&
                                    $scope.collectionTree.cid) ||
                                $scope.currentCollection.cid,
                            items: [],
                            type: "",
                            destinationFolderId: content.xid,
                            destinationFolderCollectionTree:
                                $scope.collectionTree,
                        });
                    } else {
                        $state.go("course", {
                            collectionId:
                                ($scope.collectionTree &&
                                    $scope.collectionTree.cid) ||
                                $scope.currentCollection.cid,
                            items: [],
                            type: "",
                            destinationFolderId: content.xid,
                            destinationFolderCollectionTree:
                                $scope.collectionTree,
                        });
                    }
                } else if ($scope.parent.type === "channel") {
                    $state.go("channel", {
                        collectionId:
                            ($scope.collectionTree &&
                                $scope.collectionTree.cid) ||
                            $scope.currentCollection.cid,
                        items: [],
                        type: "",
                        destinationFolderId: content.xid,
                        destinationFolderCollectionTree:
                            $scope.collectionTree,
                    });
                } else if (
                    $scope.parent.type === "protected" ||
                    $scope.parent.type === "reserves"
                ) {
                    $state.go("protected", {
                        collectionId:
                            ($scope.collectionTree &&
                                $scope.collectionTree.cid) ||
                            $scope.currentCollection.cid,
                        items: [],
                        type: "",
                        destinationFolderId: content.xid,
                        destinationFolderCollectionTree:
                            $scope.collectionTree,
                    });
                }
            };

            $scope.handleParentQuizClick = function() {
                $state.go("quizzing", {
                    isNewQuiz: false,
                    collectionType: $scope.currentCollection.type,
                    collectionId: $scope.asset.cid,
                    assetId: $scope.asset.aid,
                    isFromPnP: false
                });
            };
            $scope.handleBreadcrumbEllipsisClick = function(e) {
                $(e.target).parents('.breadcrumb').find('.breadcrumb-menu').toggle();

                setTimeout(function(){
                    if($(e.target).parents('.breadcrumb').find('.breadcrumb-menu').is(':visible')) {
                        var intervalId = setInterval(function(){
                            if($('.breadcrumb-menu li:nth-child(1) > div > span')[0].offsetWidth) {
                                clearInterval(intervalId);

                                //check each LI if there's ellipsis
                                for(var i = 0; i < $('.breadcrumb-menu li').length; i++) {
                                    if(hasEllipsisWidth($('.breadcrumb-menu li:nth-child(' + (i + 1) + ') > div > span')[0])) {
                                        $scope.crumbsForMenu[i].hasEllipsis = true;
                                    } else {
                                        $scope.crumbsForMenu[i].hasEllipsis = false;
                                    }
                                }
                            }
                        }, 100);
                        $(e.target).parents('.breadcrumb').find('.breadcrumb-menu').find('[tabindex="0"]').first().focus();
                        $(e.target).parents('.breadcrumb').find(".ellipsis").first().attr("aria-expanded",true);
                    }else{
                        $(e.target).parents('.breadcrumb').find(".ellipsis").first().attr("aria-expanded",false);
                    }
                }, 100);
            };
            $scope.handleBreadcrumbMenuItemClick = function(e, cid) {
                $scope.navigateToCollection({type: 'Collection', xid: cid});
                $(e.target).parents('.breadcrumb').find('.breadcrumb-menu').hide();
                $(e.target).parents('.breadcrumb').find('.elipse').attr("aria-expanded",false);
            };
            $scope.$watch('[parent, asset]', function(){
                if($scope.parent && $scope.asset){
                    // Get a few assets from the same parent collection to display in the sidebar
                    AssetService.GetAllAssets.get({cid: $scope.parent.cid, isActive: $scope.asset.isActive}, function (assetList) {
                        $scope.assets = assetList.assets;

                        setTimeout(() => {
                            //Add ellipsis for long titles
                            $('.sidebar-courses .course-title a').each((index, item) => {
                                $clamp(item, {clamp: 2});
                            });

                            //Add tooltip if there's ellipsis in title
                            $('.sidebar-courses .course-title a').each((index, item) => {
                                if(hasEllipsisHeight(item)) {
                                    $scope.assets[index].hasEllipsis = true;
                                }
                            });

                        }, 0)
                    });
                }
            });
            $scope.hideBreadcrumbMenuWhenClickOutside = function(e){
                console.log("hideBreadcrumbMenuWhenClickOutside()");
                if(!$(e.target).hasClass("breadcrumb-menu") &&
                    $(e.target).parents(".breadcrumb-menu").length ===0 &&
                    !$(e.target).hasClass("ellipsis") &&
                    $(e.target).parents(".ellipsis").length === 0){
                    if($(".breadcrumb-menu").is(":visible")){
                        $(".breadcrumb-menu:visible").parents('.breadcrumb').find(".ellipsis").first().attr("aria-expanded",false);
                        $('.breadcrumb-menu').hide();
                    }
                }

            };
            $(document).on("keydown.quizsubmission", function (event) {
                if (event.which === 27) {
                    if($(".breadcrumb-menu").is(":visible")){
                        $(".breadcrumb-menu:visible").parents('.breadcrumb').find('.ellipsis').first().focus();
                        $(".breadcrumb-menu:visible").parents('.breadcrumb').find(".ellipsis").first().attr("aria-expanded",false);
                        $('.breadcrumb-menu').hide();
                    }
                }
            });
            $(window).on("click.quizsubmission", function (e) {
                $scope.hideBreadcrumbMenuWhenClickOutside(e);
            });
            $scope.$on('$destroy', function() {
                console.log('quizzing-submission.controller.js controller is being destroyed, performing cleanup...');
                $(document).off("keydown.quizsubmission");
                $(window).off("click.quizsubmission");
            });
        });
    });
